import { observable, action } from "mobx";

class AppStore {
  // 初始化数据
  @observable initData = { loading: true };

  @observable condition = null;

  @action init(data) {
    this.initData = Object.assign({}, this.initData, data);
  }

  @action setData(data) {
    Object.keys(data).forEach((key) => {
      this[key] = data[key];
    });
  }

  @action async setCondition(type) {
    this.condition = type;
  }
}

export default new AppStore();
